export { default, getServerSideProps } from '../src/utils/page-legal';
